import React from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { getJobById } from '../../data/jobData';
import styles from './JobDetails.module.css';
import Footer from '../shared/Footer';

function JobDetails({ jobData }) {
  const { jobId } = useParams();
  
  // Get job data from props or by ID from URL params
  const currentJobData = jobData || getJobById(parseInt(jobId)) || getJobById(1);
  return (
    <div className={styles.section}>
      <div className={styles.container}>
        {/* Header */}
        <div className={styles.header}>
          <Link to="/careers" className={styles.backButton}>
            ‹ Back to Careers
          </Link>
          <div className={styles.jobMeta}>
            <span className={styles.jobType}>{currentJobData.type}</span>
            <span className={styles.jobLocation}>{currentJobData.location}</span>
          </div>
        </div>

        {/* Job Title */}
        <div className={styles.jobTitleSection}>
          <h1 className={styles.jobTitle}>{currentJobData.title}</h1>
          <p className={styles.jobSummary}>{currentJobData.summary}</p>
        </div>

        {/* Job Details */}
        <div className={styles.jobContent}>
          <div className={styles.contentSection}>
            <h2 className={styles.sectionTitle}>Responsibilities</h2>
            <p className={styles.sectionText}>{currentJobData.description}</p>
            <ul className={styles.arrowList}>
              {currentJobData.responsibilities.map((responsibility, index) => (
                <li key={index}>{responsibility}</li>
              ))}
            </ul>
          </div>

          <div className={styles.contentSection}>
            <h2 className={styles.sectionTitle}>Required Skills and Experience</h2>
            <ul className={styles.arrowList}>
              {currentJobData.skills.map((skill, index) => (
                <li key={index}>{skill}</li>
              ))}
            </ul>
          </div>

          <div className={styles.contentSection}>
            <h2 className={styles.sectionTitle}>Benefits</h2>
            <ul className={styles.arrowList}>
              {currentJobData.benefits.map((benefit, index) => (
                <li key={index}>{benefit}</li>
              ))}
            </ul>
          </div>

          <div className={styles.contentSection}>
            <h2 className={styles.sectionTitle}>Application Process</h2>
            <div className={styles.applicationInfo}>
              <p className={styles.applicationText}>
                Send your CV to <a href={`mailto:${currentJobData.applicationEmail}`} className={styles.emailLink}>{currentJobData.applicationEmail}</a>
              </p>
              <p className={styles.responseTime}>{currentJobData.responseTime}</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default JobDetails;
